import * as React from 'react'

import { matchCompetitionTypeTranslation } from '../../../../../../App.constants'
import { MatchCompetitionType } from '../../../../../../App.types'
import FilterMenu from '../../../../../../components/FilterMenu'
import { Localized } from '../../../../../../localization/react'
import { Action } from '../../helpers/discover-sport-matches-reducer'

import CompetitionTypeFilterForm from './CompetitionTypeFilterForm'

interface Props {
  dispatch: React.Dispatch<Action>
  selectedCompetitionTypes?: Array<MatchCompetitionType>
}

const DesktopCompetitionTypeFilter = ({ dispatch, selectedCompetitionTypes }: Props) => {
  const activeFilters = selectedCompetitionTypes?.map(
    (competitionType) => matchCompetitionTypeTranslation[competitionType],
  )
  return (
    <FilterMenu
      header={<Localized id="filters-matches-competition-type-heading" />}
      activeFilters={activeFilters}
      minWidth="162px"
    >
      <CompetitionTypeFilterForm dispatch={dispatch} selectedCompetitionTypes={selectedCompetitionTypes} />
    </FilterMenu>
  )
}

export default DesktopCompetitionTypeFilter
